export default function MODE() {
  return (
    <div className="p-4">
      <h1>MODE</h1>
    </div>
  );
}
